// store/gigSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import useAuth from "app/hooks/useAuth";

import axios from "axios";
// import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

export const ForgotPasswordPost = createAsyncThunk(
  "ForgotPasswordPost/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}login/ForgotPassword`;
      // const URL = `${process.env.REACT_APP_BASE_URL}Registration/ForgotPassword`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      console.log(response.data?.UserID);
      if (response.data?.UserID) {
        sessionStorage.setItem("LUserID", response.data.UserID);
      }
      sessionStorage.setItem("Type", response.data.Type);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const ForgetChangePassword = createAsyncThunk(
  "ForgetChangePassword/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}login/ForgetChangePassword`;

      // const URL = `${process.env.REACT_APP_BASE_URL}Registration/ForgetChangePassword`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const ForgetOTPVerification = createAsyncThunk(
  "ForgetOTPVerification/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}login/ForgetOTPVerification`;

      // const URL = `${process.env.REACT_APP_BASE_URL}Registration/ForgetOTPVerification`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const ChangeEmailIDPost = createAsyncThunk(
  "ChangeEmailIDPost/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Login/ChangeEmailID`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const ChangeMobileNoPost = createAsyncThunk(
  "ChangeMobileNoPost/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Login/ChangeMobileNo`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const ChangePasswordPost = createAsyncThunk(
  "ChangePasswordPost/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Login/ChangePassword`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==============================================================================================//
export const RegistrationPost = createAsyncThunk(
  "RegistrationPost/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Registration`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      console.log(response.data?.UserID);
      if (response.data?.UserID) {
        sessionStorage.setItem("UserID", response.data.UserID);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const PostJoinAsPost = createAsyncThunk(
  "PostJoinAsPost/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/PostJoinAs`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const PostIndustry = createAsyncThunk(
  "PostIndustry/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/PostIndustry`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const UpdatePrimaryIndustry = createAsyncThunk(
  "page/UpdatePrimaryIndustry",
  async ({ data }, { rejectWithValue }) => {
    try {
      //    const params = {
      //   data: JSON.stringify({UserID,IndustryID}),
      // };

      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdatePrimaryIndustry`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);

      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const PostResendOTP = createAsyncThunk(
  "PostResendOTP/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/ResendOTP`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const PostOTPVerification = createAsyncThunk(
  "PostJoinAsPost/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/OTPVerification`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      console.log(response.data?.EmailVerify);
      if (response.data) {
        sessionStorage.setItem("EmailVerify", response.data?.EmailVerify);
        sessionStorage.setItem("MobileVerify", response.data?.MobileVerify);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const PostSkill = createAsyncThunk(
  "PostSkill/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/PostSkill`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const UpdateSelectedSkill = createAsyncThunk(
  "page/UpdateSelectedSkill",
  async ({ data }, { rejectWithValue }) => {
    try {
      //    const params = {
      //   data: JSON.stringify({UserID,IndustryID}),
      // };

      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateSelectedSkill`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//====================SINGLE SELECT SKILL=============
export const PostsingleselectSkill = createAsyncThunk(
  "Post_single_select_Skill/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdatePrimarySkill`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const UpdateProfile = createAsyncThunk(
  "page/UpdateProfile",
  async ({ idata }, { rejectWithValue }) => {
    try {
      //    const params = {
      //   data: JSON.stringify({UserID,IndustryID}),
      // };

      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateProfile`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const UpdateProfileImages = createAsyncThunk(
  "page/UpdateProfile",
  async ({ data }, { rejectWithValue }) => {
    try {
      //    const params = {
      //   data: JSON.stringify({UserID,IndustryID}),
      // };

      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateProfileImages`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================EXPERIENCE=====================//
export const PostUserExperience = createAsyncThunk(
  "PostUserExperience/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/AddExperience`;

      // const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/PostUserExperience`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================EDUCATION=====================//
// export const PostUserEducation= createAsyncThunk(
//   "PostUserEducation/POST",
//   async ({ data }, { rejectWithValue }) => {
//     try {
//       const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/AddEducation`;

//       // const URL = `${process.env.REACT_APP_BASE_URL}Registration/PostUserEducation`;
//       const response = await axios.post(URL, data, {
//         headers: {
//           Authorization: process.env.REACT_APP_API_TOKEN,
//         },
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response ? error.response.data : error.message
//       );
//     }
//   }
// );
export const PostUserEducation = createAsyncThunk(
  "PostUserEducation/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/AddEducation`;

      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      console.log("Server Raw Response:", response); // 👈 Add this
      console.log("Returned Data:", response.data); // 👈 Add this

      return response.data;
    } catch (error) {
      console.error("Thunk Error:", error.response || error.message);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================EDUCATION=====================//
export const PostLogin = createAsyncThunk(
  "PostLogin/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Login/Login`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================PostUserLanguage=====================//
export const PostUserLanguage = createAsyncThunk(
  "PostUserLanguage/POST",
  async ({ Ldata }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    console.log("user.Token;", token);
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}MyAccount/PostUserLanguage`;
      const response = await axios.post(URL, Ldata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================Projectcomment/Delete=====================//
export const ProjectcommentDelete = createAsyncThunk(
  "Network/ProjectcommentDelete",
  async ({ RecordID }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    console.log("user.Token;", token);
    const params = {
      data: JSON.stringify({ RecordID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Project/DeleteProjectComment`;
      const response = await axios.delete(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================POST/comment/Delete=====================//
export const PostcommentDelete = createAsyncThunk(
  "Network/PostcommentDelete",
  async ({ RecordID }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    console.log("user.Token;", token);
    const params = {
      data: JSON.stringify({ RecordID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Post/DeletePostComment`;
      const response = await axios.delete(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================PostUserLanguage=====================//
export const DeleteUserLanguage = createAsyncThunk(
  "DeleteUserLanguage/POST",
  async ({ RecordID }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    console.log("user.Token;", token);
    const params = {
      data: JSON.stringify({ RecordID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}MyAccount/DeleteUserLanguage`;
      const response = await axios.delete(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================SignUpEmail OTP Back ICON=====================//
export const DeleteSignupEmail = createAsyncThunk(
  "DeleteSignupBack/POST",
  async ({ UserID }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");
    const getuser = sessionStorage.getItem("UserID");

    console.log("user.Token;", token);
    const params = {
      data: JSON.stringify({ UserID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}DeleteRegisterUser?data={"UserID":${getuser}}`;
      console.log(params, "--find paramas");

      const response = await axios.delete(URL, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      });

      if (response.data?.UserID) {
        sessionStorage.ge("UserID", response.data.UserID);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//====================UpdateLookingFor=================================//
export const UpdateLookingFor = createAsyncThunk(
  "page/UpdateLookingFor",
  async ({ data }, { rejectWithValue }) => {
    try {
      //    const params             = {
      //   data: JSON.stringify({UserID,IndustryID}),
      // };

      const URL = `${process.env.REACT_APP_BASE_URL}Registration/UpdateLookingFor`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      });
      if (response.data?.Token) {
        sessionStorage.setItem("authToken", response.data.Token);
      }
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//====================SavedPOST/REPORTPOST=================================//
export const GetreportPOST = createAsyncThunk(
  "SavedPOST/REPORTPOST",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      const URL = `${process.env.REACT_APP_BASE_URL}Home/ReportUser`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.Token) {
        sessionStorage.setItem("authToken", response.data.Token);
      }
      console.log(response.data);
      return response.data;
    } catch (error) {
      // Handle errors, including network or authorization issues
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================EXPERIENCE=====================//
export const PostUserHeadshot = createAsyncThunk(
  "PostUserHeadshot/POST",
  async ({ hdData }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}MyAccount/PostUserHeadshot`;
      const response = await axios.post(URL, hdData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=================================CHANGE-EMAIL===============================//
export const ChangeEmail = createAsyncThunk(
  "ChangeEmail/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Settings/ChangeEmail`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================ChangePassword=====================//
export const ChangePassword = createAsyncThunk(
  "ChangePassword/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Settings/ChangePassword`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================================================================//
//===================ChangePhoneNumber=====================//
export const ChangePhoneNumber = createAsyncThunk(
  "ChangePhoneNumber/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Settings/ChangePhoneNumber`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================CreatePost=====================//
export const CreatePosts = createAsyncThunk(
  "CreatePost/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Post/CreatePost`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================CreateGig=====================//
export const CreateGig = createAsyncThunk(
  "CreateGig/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GigWork/AddGigWork`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================CreateJob=====================//
export const CreateJob = createAsyncThunk(
  "CreateJob/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Jobs/CreateJob`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================PostUnionAssociation=====================//
export const PostUnionAssociations = createAsyncThunk(
  "PostUnionAssociation/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Settings/PostUnionAssociation`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//========================Internship/PostInternship====================================
export const PostInternship = createAsyncThunk(
  "PostInternship/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Internship/AddInternship`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=====================MyProfile / Upload Image ===============================

export const UpdateCoverImage = createAsyncThunk(
  "UpdateCoverImage/PUT/MyProfile",
  async (data, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      const URL = `${process.env.REACT_APP_BASE_URL}MyAccount/UpdateCoverImage`;

      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//========================GigWork/PostGigWork====================================
export const PostGigWork = createAsyncThunk(
  "PostGigWork/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");
      console.log("user.Token;", token);

      const URL = `${process.env.REACT_APP_BASE_URL}GigWork/PostGigWork`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//========================Support/ContactSupport_POST====================================

export const ContactSupportPost = createAsyncThunk(
  "ContactSupportPost/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}ContactSupport/PostContactSupport`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//========================Internship/PostApprenticeship====================================

export const PostApprenticeship = createAsyncThunk(
  "PostApprenticeship/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Apprenticeship/AddApprenticeship`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//========================GET HIRED _Project/PostProject====================================

export const PostProject = createAsyncThunk(
  "PostProjectGethired/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Project/AddProject`;

      // const URL = `${process.env.REACT_APP_BASE_URL}Project/PostProject`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//========================Project/PostProject====================================

export const PostNotification = createAsyncThunk(
  "PostNotification/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Settings/PostNotification`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================================DeleteDevice==================================/
export const DeleteDevice = createAsyncThunk(
  "DeleteDevice/POST",
  async ({ RecordID }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    console.log("user.Token;", token);
    const params = {
      data: JSON.stringify({ RecordID }),
    };
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Settings/DeleteDevice`;
      const response = await axios.delete(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//========================PostApply====================================

export const PostApply = createAsyncThunk(
  "PostApply/Post",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Apply/PostApply`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//========================FollowRequest====================================

export const FollowRequest = createAsyncThunk(
  "FollowRequest/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Profile/FollowRequest`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//========================UnFollowRequest====================================

export const UnFollowRequest = createAsyncThunk(
  "UnFollowRequest/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Profile/UnFollowRequest`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//========================BlockUser====================================

export const BlockUser = createAsyncThunk(
  "BlockUser/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Profile/BlockUser`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//========================UnBlockUser====================================

export const UnBlockUser = createAsyncThunk(
  "UnBlockUser/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Profile/UnBlockUser`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//========================AddBookMark====================================

export const AddBookMark = createAsyncThunk(
  "AddBookMark/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);

      const URL = `${process.env.REACT_APP_BASE_URL}Apply/AddBookMark`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//========================RemoveBookMark====================================

export const RemoveBookMark = createAsyncThunk(
  "RemoveBookMark/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Apply/RemoveBookMark`;

      // const URL = `${process.env.REACT_APP_BASE_URL}ApplyController/RemoveBookMark`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==============================POSTLIKE==NETWORK/POST=================================
export const PostLike = createAsyncThunk(
  "PostLike/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Post/PostLike`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==============================HOME/ Notification=====================//

export const clearNotificationPost = createAsyncThunk(
  "ClearNotification/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Notification/ClearNotification`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==============================HOME/ Notification=====================//

export const ReadNotificationPost = createAsyncThunk(
  "ReadNotification/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Notification/ReadNotification`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=======================Home/ UpdateEndorsementStatus =================//

export const UpdateEndorsementStatusPost = createAsyncThunk(
  "ReadNotification/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}MyAccount/UpdateEndorsementStatus`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==============================POSTComment==NETWORK/POST=================================
export const PostComment = createAsyncThunk(
  "PostComment/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Post/CreatePostComment`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==============================ProjectLIKE==NETWORK/PROJECT=================================
export const ProjectLike = createAsyncThunk(
  "ProjectLike/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Project/ProjectLike`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==============================ProjectComments==NETWORK/PROJECT=================================
export const ProjectComments = createAsyncThunk(
  "ProjectComments/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Project/CreateProjectComment`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//========================UpdateApplicationStatus====================================

export const UpdateApplicationStatus = createAsyncThunk(
  "UpdateApplicationStatus/Post",
  async (idata, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/UpdateApplicationStatus`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================================PersonalChatPost=================================//
export const SendPersonalChatMessage = createAsyncThunk(
  "SendPersonalChatMessage/Post",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}PersonalChat/PostPersonalChat`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================================PersonalChatMessageRead=================================//
export const PersonalChatMessageRead = createAsyncThunk(
  "PersonalChatMessageRead/Post",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}PersonalChat/PersonalChatMessageRead`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GROUP-CREATION======================//
export const CreateGroup = createAsyncThunk(
  "CreateGroup/Post",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/CreateGroup`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GROUP-ADD-MEMBERS======================//
export const AddUser = createAsyncThunk(
  "AddUser/Post",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/AddGroupMembers`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//========================GroupChat/SendGroupMessage=========================//
export const SendGroupMessage = createAsyncThunk(
  "SendGroupMessage/Post",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/PostGroupMessage`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================================ReadMessage=================================//
export const GroupChatMessageRead = createAsyncThunk(
  "ReadMessage/Post",
  async ({ GroupID, UserID }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/ReadMessage`;
      const response = await axios.put(
        URL,
        { GroupID, UserID },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GroupChat/LeaveGroup=======================//
export const LeaveGroup = createAsyncThunk(
  "page/LeaveGroup",
  async ({ UserID, GroupID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, GroupID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/RemoveUser`;

      const response = await axios.delete(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==================================GroupChat/DeleteGroup=======================//
export const DeleteGroup = createAsyncThunk(
  "page/DeleteGroup",
  async ({ UserID, GroupID }, { rejectWithValue }) => {
    try {
      const params = {
        data: JSON.stringify({ UserID, GroupID }),
      };
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}GroupChat/DeleteGroup`;

      const response = await axios.delete(URL, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==============Login/Logout=======================================//
export const LogoutID = createAsyncThunk(
  "Logout/Post",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);
      const URL = `${process.env.REACT_APP_BASE_URL}Login/Logout`;
      const response = await axios.post(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================Settigs/Account Settings=====================//

// export const DeleteAccountPost= createAsyncThunk(
//   "gethired_Basicinfo/POST",
//   async ({ data }, { rejectWithValue }) => {

//     try {
//       const URL = `${process.env.REACT_APP_BASE_URL}Settings/DeleteAccount`;
//       const response = await axios.delete(URL, data, {
//         headers: {
//           Authorization: process.env.REACT_APP_API_TOKEN,
//         },
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response ? error.response.data : error.message
//       );
//     }
//   }
// );

// export const DeleteAccountPost = createAsyncThunk(
//   "gethired_BasicinfoDeleteAccountPost/POST",
//   async ({ data }, { rejectWithValue }) => {
//     const token = sessionStorage.getItem("authToken");
//  const params = {
//         // data: JSON.stringify({data}),
//                 data: data,

//       };
//       console.log(params, "--params");

//     try {
//       const URL = `${process.env.REACT_APP_BASE_URL}Settings/DeleteAccount`;
//       const response = await axios.delete(URL, {
//         params,
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         data: data, // ✅ correct place to include body
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response ? error.response.data : error.message
//       );
//     }
//   }
// );

export const DeleteAccountPost = createAsyncThunk(
  "gethired_BasicinfoDeleteAccountPost/POST",
  async ({ idata }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("authToken");

      console.log("user.Token;", token);

      const URL = `${process.env.REACT_APP_BASE_URL}Settings/DeleteAccount`;

      // ✅ Laravel expects the param 'data' as a JSON string
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        // params: {
        //   data: JSON.stringify(data), // ✅ encode as string
        // },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===================GET HIRED/PROFILE BASIC INFO=====================//
export const GetHiredbasicinfo = createAsyncThunk(
  "gethired_Basicinfo/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateUserProfile`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===================GET HIRED/PROFILE BASIC INFO/SEND OTP=====================//
export const GetHiredbasicinfoOTP = createAsyncThunk(
  "gethired_Basicinfo_OTP/POST",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/SendOTP`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===============================ChooseUserOnboardingType===========================================//
export const ChooseUserOnboardingType = createAsyncThunk(
  "ChooseUserOnboardingType/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/ChooseUserOnboardingType`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//===============================UpdateOrganiationType===========================================//
export const UpdateOrganizationType = createAsyncThunk(
  "UpdateOrganizationType/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateOrganizationType`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//===============================UpdateOrganiationType===========================================//
export const UpdateUserProfile = createAsyncThunk(
  "UpdateUserProfile/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateUserProfile`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
// //==============================UserProfile/UpdateStudioProjectType============================//
//   export const UpdateStudioProfile = createAsyncThunk(
//   "UpdateStudioProfile/Put",
//   async ({ data }, { rejectWithValue }) => {
//     try {
//       const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateStudioProfile`;
//       const response = await axios.put(URL, data, {
//         headers: {
//           Authorization: process.env.REACT_APP_API_TOKEN,
//         },
//       });

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response ? error.response.data : error.message
//       );
//     }
//   }
// );

//==============================UserProfile/UpdateStudioProfile============================//
export const UpdateStudioProfile = createAsyncThunk(
  "UpdateStudioProfile/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateStudioProfile`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==============================UserProfile/UpdateStudioProjectType============================//
export const UpdateStudioProjectType = createAsyncThunk(
  "UpdateStudioProjectType/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateStudioProjectType`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//==============================UserProfile/UpdateStudioProjectType============================//
export const UpdateRoles = createAsyncThunk(
  "UpdateRoles/Put",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/UpdateRoles`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//==============================UserProfile/UpdateStudioProjectType============================//
export const AddProject = createAsyncThunk(
  "AddProject/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Project/AddProject`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const uploadMedia_v1 = createAsyncThunk(
  "uploadMedia_v1/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}uploadMedia_v1`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const AddCollaborator = createAsyncThunk(
  "AddCollaborator/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Project/AddCollaborator`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const AddEndorsement = createAsyncThunk(
  "AddEndorsement/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Project/AddEndorsement`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const AddExperience = createAsyncThunk(
  "AddExperience/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/AddExperience`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const AddEducation = createAsyncThunk(
  "AddEducation/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/AddEducation`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const AddUnionAssociation = createAsyncThunk(
  "AddUnionAssociation/Post",
  async ({ data }, { rejectWithValue }) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}UserProfile/AddUnionAssociation`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const ScheduleInterview = createAsyncThunk(
  "ScheduleInterview/Post",
  async ({ data }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/ScheduleInterview`;

      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const AddNotes = createAsyncThunk(
  "AddNotes/Post",
  async ({ data }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/AddNotes`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const UpdateAppliedApplicationStatus = createAsyncThunk(
  "UpdateAppliedApplicationStatus/Post",
  async ({ data }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/UpdateAppliedApplicationStatus`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const UpdateRating = createAsyncThunk(
  "UpdateRating/Post",
  async ({ data }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Hiring/UpdateRating`;
      const response = await axios.put(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=================Subscription/createOrder====================//
export const createOrder = createAsyncThunk(
  "createOrder/Post",
  async ({ data }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Subscription/createOrder`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=================Subscription/createOrder====================//
export const verifyPayment = createAsyncThunk(
  "verifyPayment/Post",
  async ({ data }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Subscription/verifyPayment`;
      const response = await axios.post(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=============Subscription/ManagePlan=============//
export const ManagePlan = createAsyncThunk(
  "ManagePlan/Post",
  async ({ idata }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Subscription/ManagePlan`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//=================Subscription/createOrder====================//
export const verifyManagePlan = createAsyncThunk(
  "verifyManagePlan/Post",
  async ({ idata }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Subscription/verifyManagePlan`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//=================Subscription/createOrder====================//
export const UpdateStatus = createAsyncThunk(
  "UpdateStatus/Post",
  async ({ idata }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}Subscription/UpdateStatus`;
      const response = await axios.put(URL, idata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
//========================DeletePersonalChatMessage=========================//

export const DeletePersonalChatMessage = createAsyncThunk(
  "Message/DeletePersonalChatMessage",
  async ({ idata }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("authToken");

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}PersonalChat/DeletePersonalChatMessage`;
      const response = await axios.delete(URL, {
        data: idata, // ✅ body goes here
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
const postSlice = createSlice({
  name: "postSlice",
  initialState: {
    user: null,
    loading: false,
    error: null,
    post: null,
    posts: [],
  },
  reducers: {
    addPost: (state, action) => {
      state.post = action.payload; // active post
      state.posts.push(action.payload); // history (optional)
    },

    clearPost: (state) => {
      state.post = null; // ✅ clear ONLY active post
    },

    // addPost: (state, action) => {
    //   state.post = action.payload;       // Store latest post
    //   state.posts.push(action.payload);  // Keep history
    // },
    // clearPost: (state) => {
    //   state.post = null; // 👈 reset here
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PostLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(PostLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;

        // ✅ Store in sessionStorage
        sessionStorage.setItem("user", JSON.stringify(action.payload));
      })
      .addCase(PostLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addPost, clearPost } = postSlice.actions;
export default postSlice.reducer;
